import { render, staticRenderFns } from "./waterUsageTerms.vue?vue&type=template&id=39c12fac&scoped=true"
import script from "./waterUsageTerms.vue?vue&type=script&lang=js"
export * from "./waterUsageTerms.vue?vue&type=script&lang=js"
import style0 from "./waterUsageTerms.vue?vue&type=style&index=0&id=39c12fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c12fac",
  null
  
)

export default component.exports